// extracted by mini-css-extract-plugin
export var center = "_1l-2";
export var clickableRow = "_1l-5";
export var expandedRow = "_1l-7";
export var hoverable = "_1l-4";
export var left = "_1l-1";
export var right = "_1l-3";
export var row = "_1l-0";
export var selectedRow = "_1l-6";
export var summaryRow = "_1l-8";